/**
 * 公司
 */

 import {
    get,
    post,
    put,
    del
  } from '@/util/request'

  /**
   * 根据Id查询
   * @param {*} Id
   * @returns
   */
  export const SelectCompanyById = (Id) => {
    return get('/api/app/Company?CurrentId=' + Id);
  }

  /**
   * 新增数据记录
   * @param {*} data
   * @returns
   */
  export const AddCompany = (data) => {
    return post('/api/app/Company', data, {});
  }

  /**
   * 更新数据记录
   * @param {*} data
   * @returns
   */
  export const ModifyCompany = (data) => {
    return put('/api/app/Company', data, {});
  }

  /**
   * 分页获取
   * @param {*} data
   * @returns
   */
  export const GetDataCompanyList = (data) => {
    return post('/api/app/Company/list', data, {});
  }

  /**
   * 删除记录
   * @param {*} id
   * @returns
   */
  export const DeleteCompany = (id) => {
    return del('/api/app/Company/' + id, {}, {});
  }


  /**
   * 通过UserCode获取所属公司下的部门和用户
   * @param {*} code
   * @returns
   */
   export const GetDataByUserCode = (code) => {
    return get('api/app/company/dataByUserCode?userCode='+code);
  }